import React from "react";
import "./Loader.css";
import loaderlogo from "../../assets/banner/loaderlogo.png";
import lodertext from "../../assets/banner/loadertext.png";

const Loader = () => {
  return (
    <div className="spinner-container">
      <div className="spinner-content">
        <img src={loaderlogo} alt="Loader Logo" className="loader-logo" />
        <img src={lodertext} alt="Loader Text" className="loader-text" />
        <div className="loader-bar"></div>
      </div>
    </div>
  );
};

export default Loader;